import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ThankYou.module.css';

const ThankYou: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => { if (window.gtag) window.gtag('event', 'conversion', { send_to: process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID || '' }); if (window.fbq) window.fbq('track', 'Lead'); }, []);
  return <main className={styles.container}><div className={styles.card}><div className={styles.icon}>✓</div><p className={styles.eyebrow}>Заявката е изпратена</p><h1>Благодарим Ви!</h1><p>Ще се свържем с Вас до 24 часа, за да уточним детайлите и най-подходящия следващ ход.</p><button type="button" onClick={() => navigate('/')}>Обратно към сайта <span>→</span></button></div></main>;
};
export default ThankYou;
